import {createContext, useContext, useState} from "react";
import {useTable} from "hooks/useTable";
import SliderApi from "api/slider.api";
import {
    serviceSliderDestroy,
    serviceSliderOrder,
    serviceSliderSave,
    serviceSliderUpdateAction
} from "services/slider.service";

const SliderContext = createContext();

export const SliderProvider = ({children}) => {

    const translateKey = 'crm.Slider';
    const permission = 'slider';
    const [tableRow, setTableRow] = useState({});
    const [filter, setFilter] = useState({});
    const [modal, setModal] = useState({
        form: false
    });

    const {dataSource, setDataSource, loading: tableLoading, fetchDataSource, handleQuery, query} = useTable(SliderApi.getIndex);

    const handleFilter = (newFilter) => {
        setFilter(f => ({
            ...f,
            ...newFilter
        }))
    }

    const handleModal = (name, action, data = {}) => {
        setModal(m => ({
            ...m,
            [name]: action
        }))
        setTableRow(data);
    }

    const handleAction = async (id, action = 'is_active') => {
        const res = await serviceSliderUpdateAction(id, action);
        if (res) await fetchDataSource();
    }

    const handleDelete = async (id) => {
        const res = await serviceSliderDestroy(id);
        if (res) await fetchDataSource();
    }

    const handleSave = async (form) => {
        const res = await serviceSliderSave(form)
        if (res) {
            await fetchDataSource();
            return true;
        }
        return false;
    }

    const handleOrderChange = async (value, id) => {
        const index = dataSource.data.findIndex(i => i.id === id);
        dataSource.data[index].order = value;
        setDataSource(d => ({
            ...d,
            data: [...dataSource.data]
        }));
    }

    const handleOrderSave = async (value, id) => {
        if (value && id) {
            const res = await serviceSliderOrder(id, {order: value});
            if (res) {
                await fetchDataSource()
            }
        }
    }

    const values = {
        translateKey,
        modal,
        permission,
        filter,
        tableRow,
        dataSource,
        query,
        tableLoading,
        fetchDataSource,
        handleQuery,
        handleModal,
        handleFilter,
        handleAction,
        handleDelete,
        handleSave,
        handleOrderChange,
        handleOrderSave
    };

    return <SliderContext.Provider value={values}>
        {children}
    </SliderContext.Provider>
}

export const useSliderContext = () => useContext(SliderContext);
